import Swal from "sweetalert2";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import { getAccountData } from "./get-account-data";

async function confirmarPedidoEmNomeCliente(cnpj, nomeJaResolvido = null) {
	if (!cnpj) {
		return true;
	}

	let empresa = "-";
	let fantasia = "-";
	let cnpjFormatado = CnpjUtils.formatCnpj(cnpj);

	if (nomeJaResolvido) {
		empresa = nomeJaResolvido;
		fantasia = nomeJaResolvido;
	} else {
		try {
			const data = await getAccountData(cnpj);
			if (data?.nome) {
				empresa = data.nome;
			}
			fantasia = data?.fantasia || empresa;
			if (data?.cnpj) {
				cnpjFormatado = CnpjUtils.formatCnpj(data.cnpj);
			}
		} catch (error) {
		}
	}

	const html = `Você está prestes a passar um pedido em nome do seguinte cliente:<br/><br/>Empresa: <b>${empresa}</b><br/>Nome Fantasia: <b>${fantasia}</b><br/>CNPJ: <b>${cnpjFormatado}</b><br/><br/>Deseja continuar?`;

	const result = await Swal.fire({
		html,
		icon: "warning",
		title: "Atenção",
		width: "600px",
		showCancelButton: true,
		confirmButtonColor: "#3085d6",
		cancelButtonColor: "#d33",
		confirmButtonText: "Sim",
		cancelButtonText: "Não",
	});

	return !!result?.value;
}

export { confirmarPedidoEmNomeCliente };
